<script setup lang="ts">
import { BuyerBundlesQuery } from '@gql/BuyerBundlesQuery'

const t2 = useT2({
  Bundles: 'Rinkiniai',
})

const props = defineProps<{
  product: ProductListingFragmentFull | None
}>()

const elem = useTemplateRef('elem')
const scrolHelp = useTemplateRef('scrolHelp')

const data = shallowReactive({
  loadMore: false,
})

const queryyy = useApolloWrap2<gen.BuyerBundlesQuery, gen.BuyerBundlesQueryVariables>(BuyerBundlesQuery)({
  clientId: 'get',
  ui: (i) => {
    const val = i?.buyerBundles
    return { items: helpers.arr(val?.items), cursorNext: val?.cursorNext }
  },
  vars() {
    const groupId = props.product?.groupId
    if (!groupId) return
    return { input: { groupId, cursorNext: undefined, size: 6 } }
  },
  on() {
    scrolHelp.value?.checkSize()
  },
})

const loadMore2 = useApolloWrapLoadMore(queryyy, {
  ui: (i) => i.buyerBundles,
  variables: ({ input, result }) => ({
    isValid: !!result.cursorNext,
    input: { input: { ...input.input, cursorNext: result.cursorNext } },
  }),
  result: ({ next, prev }) => ({
    buyerBundles: {
      ...prev,
      cursorNext: next?.cursorNext,
      items: [...helpers.arr(prev?.items), ...helpers.arr(next?.items)],
    },
  }),
})
function loadMore() {
  data.loadMore = true
  return loadMore2()
}

const { ui } = queryyy
</script>

<template>
  <UiGrow :open="!!ui.items.length">
    <UiUpper class="_pt1 _pb1 _pl2 _pr2" :title="t2('Bundles')"><IconBundle class="_svg16" /></UiUpper>

    <div class="_relative _w100p">
      <div ref="elem" class="_row _scrollX _relative _stretch _w100p" :class="data.loadMore ? '_wrap' : '_h250 _pl2 _pr8 m_pl1'" @scroll.passive="() => scrolHelp?.onScroll()">
        <div v-for="item in ui.items" :key="item._id" class="_a1" :class="data.loadMore ? $style.b2 : '_noflex _h250'">
          <ProductBundleBox :item :listings="undefined" :profiles="undefined" glow />
        </div>
      </div>
      <LazyUiScrollArrows v-if="!data.loadMore" ref="scrolHelp" auto :elem="() => elem" />
    </div>

    <ButtonLoadMore class="_pt2 _pl2 _pr2 _h64" :submit="loadMore" :cursor="ui.cursorNext" />
  </UiGrow>
</template>

<style module>
.b2 {
  composes: global(_wmin280);
  composes: global(_flex);
  max-width: 50%;
}
</style>
